<template>
    <BaseMapShell v-model:panelOpen="panelOpen" :center="center" :zoom="zoom" :bounds="bounds" :max-bounds="maxBounds"
        :minZoom="3" :maxZoom="19">
        <template v-if="mission">
            <BaliseMarker v-for="balise in mission.balises" :key="balise.id" :balise="balise" :followMode="false"
                :warning="true" :warningColor="balise.ongoingAlarm ? 'red' : 'blue'" />
            <BaliseMarker :balise="mission.transporteur" :followMode="false" :warning="true"
                :warningColor="mission.transporteur?.ongoingAlarm ? 'red' : 'blue'" />
            <CorridoringDisplay v-if="mission?.corridoring?.id" :corridoringId="mission.corridoring.id"
                @loaded="onCorridoringLoaded" />
        </template>
    </BaseMapShell>
</template>

<script>
import CorridoringDisplay from "../Components/CorridoringDisplay.vue";
import BaliseMarker from "../Components/BaliseMarker.vue";
import MissionRepository from '@/repositories/mission.repo.js'
import BaseMapShell from "../BaseMapShell.vue";
import { computePaddedBounds } from "../composables/useBounds";

export default {
    components: {
        BaseMapShell,
        CorridoringDisplay,
        BaliseMarker,
    },
    data() {
        return {
            panelOpen: false,
            zoom: 13,
            center: [48.9571487, 2.1941876],
            timer: '',
            bounds: [],
            maxBounds: [],
            mission: null,
        };
    },
    created() {
        this.refreshData();
        this.timer = setInterval(this.refreshData, 5000);
    },
    beforeUnmount() {
        clearInterval(this.timer);
    },
    methods: {
        async refreshData() {
            try {
                this.mission = await MissionRepository.getMission(this.$route.params.id);
            } catch (e) {
                console.log(e);
            }
        },
        onCorridoringLoaded(positions) {
            // Bounds robustes (>= 2 points) sinon on reste sur center/zoom
            this.$nextTick(() => {
                if (Array.isArray(positions) && positions.length >= 2) {
                    this.bounds = computePaddedBounds(positions /* right panel pas ouvert ici */);
                } else if (Array.isArray(positions) && positions.length === 1) {
                    this.bounds = [];
                    this.center = [positions[0].latitude, positions[0].longitude];
                    this.zoom = 15;
                } else {
                    this.bounds = [];
                }
            });
        },
    }
}
</script>